module.exports = __webpack_public_path__ + "img/dialog.ca5f604e.png";